import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";
import styled from "styled-components";
import { colorDustyWhite, colorText } from "@/utils/palette";
import { left } from "@/utils/directions";
import CertificateTimeLineItem from "./Certificatetimeline";

const TrackingPackageModal = ({ show, handleClose, product }) => {
    console.log("🚀 ~ TrackingPackageModal ~ product:", product)
    const NoImg = `${process.env.PUBLIC_URL}/img/no-img.png`;

    return (
        <Modal show={show} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Package Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <div className="">
                        {/* Image Slider */}
                        <div className=" hero-img py-1 justify-content-center">
                            <div className="">
                                <Swiper
                                    modules={[Navigation, Pagination, EffectFade, Autoplay]}
                                    spaceBetween={10}
                                    slidesPerView={1} // Show one image at a time
                                    navigation
                                    pagination={{ clickable: true }}
                                    loop={true}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                >
                                    {product?.image?.length > 0 ? (
                                        product.image.map((item, index) => (
                                            <SwiperSlide key={index}>
                                                <img
                                                    src={item || NoImg}
                                                    alt={`slide_${index}`}
                                                    className="d-block w-100"
                                                    style={{
                                                        height: "250px",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            </SwiperSlide>
                                        ))
                                    ) : (
                                        <SwiperSlide>
                                            <img
                                                src={NoImg}
                                                alt="No Image"
                                                className="d-block w-100"
                                                style={{
                                                    height: "250px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                            </div>
                        </div>

                        {/* Package Details */}
                        <div className="col-lg-8 d-flex flex-column justify-content-center py-1 px-4">
                            <h2 className="text-black" style={{ textTransform: 'capitalize' }}>
                                {product?.package_name || "No Name"}
                            </h2>

                            <div className="row px-2 py-3">
                                <div className="col-12">
                                    <Row>
                                        <Col sm={6}>
                                            <p className="py-1 mb-0 text-black"><b>General Description</b></p>
                                            <p className="py-0 mb-2 text-black">{product?.package_description || "No Description Available"}</p>
                                        </Col>

                                        {product?.document?.length > 0 && (
                                            // <Row>
                                            <Col sm={6}>
                                                <p className="py-1 mb-0 text-black"><b>Documents</b></p>
                                                {product.document.map((item, idx) => (
                                                    <Button
                                                        key={idx}
                                                        variant="outline-primary"
                                                        href={item}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="m-1"
                                                    >
                                                        Doc {idx + 1}
                                                    </Button>
                                                ))}
                                            </Col>
                                            // </Row>
                                        )}
                                    </Row>

                                    {/* Document Links */}

                                </div>
                            </div>
                        </div>


                        <TimeLineWrap>
                            {product?.owner?.map((ownerItem) => (
                                <CertificateTimeLineItem
                                    key={ownerItem._id}
                                    hash={product.transaction_id}
                                    title={product.package_name || ""}
                                    date={new Date(ownerItem.createdAt).toLocaleDateString()}
                                    description={product.package_description}
                                    documentLink={product.document}
                                    type={product.otc_type}
                                    origin={product.origin}
                                    location={product.location}
                                    batchNumber={product.batch_number}
                                    img={ownerItem.profile[0]?.image}
                                    email={ownerItem.profile[0]?.email}
                                />
                            ))}
                        </TimeLineWrap>
                    </div>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TrackingPackageModal;
const TimeLineWrap = styled.div`
  position: relative;
  color: ${colorText};

  &:before {
    content: "";
    background-color: ${colorDustyWhite};
    width: 1px;
    height: 100%;
    position: absolute;
    ${left}: 50%;
  }

  p {
    margin-top: 5px;
  }

  @media screen and (max-width: 991px) {
    &:before {
      ${left}: 25px;
    }
  }
`;